import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Icon, Tooltip } from 'antd'
import custom from '../../config/custom'
import _ from 'lodash'

class DispatchDocs extends Component {

  state = {
    printing: false
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  printing() {
    window.open(`${custom.baseUrl}/dispatch/${this.props.id}/pdf`)
  }

  openInGoogleMaps(origin, destination) {
    window.open(`https://maps.google.com?saddr=${encodeURIComponent(origin.address)}&daddr=${encodeURIComponent(destination.address)}&dirflg=d`)
  }

  render() {
    const dispatch = _.find(this.props.dispatches, { id: this.props.id })
    return (
      <Fragment>
        <Tooltip title={dispatch.canceledAt ? null : 'Mostrar ruta'}>
          <Button
            disabled={dispatch.canceledAt}
            onClick={e => {
              e.stopPropagation()
              this.openInGoogleMaps(dispatch.origin, dispatch.destination)
            }}
            size="small"
          >
            <Icon type="compass" />
          </Button>
        </Tooltip>
        {
          dispatch.customer &&
          dispatch.files && Boolean(dispatch.files.length) &&
          <Tooltip title={dispatch.canceledAt ? null : 'Mostrar documentos en G-Files'}>
            <Button
              disabled={dispatch.canceledAt}
              onClick={e => {
                e.stopPropagation()
                const startPadding = dispatch.id > 850 ? 5 : 6
                window.open(`https://files.g-global.com.mx/files#!/${dispatch.customer.sapId}/transporte/TMS-${_.padStart(dispatch.id, startPadding, 0)}/`)
              }}
              size="small"
            >
              <Icon type="paper-clip" />
            </Button>
          </Tooltip>
        }
        <Tooltip title={dispatch.canceledAt ? null : 'Mostrar Carta Porte'}>
          <Button
            disabled={dispatch.canceledAt}
            onClick={e => {
              e.stopPropagation()
              this.printing()
            }}
            loading={this.state.printing}
            size="small"
          >
            <Icon type="file-text" />
          </Button>
        </Tooltip>
      </Fragment>
    )
  }

}

const mapStateToProps = state => ({
  dispatches: state.dispatch.items
})

export default connect(mapStateToProps)(DispatchDocs)



// WEBPACK FOOTER //
// ./src/containers/DispatchDocs/index.js